'use strict';

exports.__esModule = true;
exports.default = NoGovernessError;
function NoGovernessError(message) {
  this.name = 'NoGovernessError';
  this.message = message || 'Governess must be an instance of HeadGoverness.';
}

NoGovernessError.prototype = Error.prototype;


//////////////////
// WEBPACK FOOTER
// ./~/kindergarten/lib/errors/NoGovernessError.js
// module id = ntXP
// module chunks = 0